import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import {NavLink, useNavigate} from "react-router-dom";
import bannerImage from "../img/thumb/photo-1920x156.jpg";
import IconThaID from "../img/thumb/ThaID.png";
import toast, { Toaster } from 'react-hot-toast';
import moment from "moment-timezone";
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';

export default function Login(prop) {
    let navigate = useNavigate();

    let [passwordInputType, setPasswordInputType] = React.useState('password');
    let [disabledBtn, setDisabledBtn] = React.useState(false);
    let [isVerifyCode, setIsVerifyCode] = React.useState(false);
    let [email, setEmail] = React.useState(null);
    let [count, setCount] = React.useState(0);

    let refEmail = React.useRef();
    let refPassword = React.useRef();
    let refCaptcha = React.useRef();

    React.useEffect(() => {
        document.title = 'เข้าสู่ระบบ | NCSA';

        if(prop.member) {
            navigate((prop.lang === 'en' ? '/en':'/') + 'profile');
        }

        if(!isVerifyCode) {
            loadCaptchaEnginge(6, '#2A2B71', '#FFFFFF');
        }

        (async function() {
            try {
            } catch (e) {
                //
            }
        })();
    }, []);

    const onSubmit = async () => {
        let email = refEmail.current.value;
        let password = refPassword.current.value;
        let captcha = refCaptcha.current.value;

        if(email === '' || !Utils.validateEmail.test(email)) {
            toast.error(prop.lang === 'en' ? 'Please specify a valid email':'กรุณาระบุ รูปแบบอีเมลให้ถูกต้อง');
            refEmail.current.focus();
        }
        else if(password === '' || !Utils.strengthPassword.test(password)) {
            toast.error((prop.lang === 'en' ? 'Please specify a valid password':'กรุณาระบุ รหัสผ่านให้ถูกต้อง') + '\n\n' + Utils.passwordAlert(prop.lang));
            refPassword.current.focus();
        }
        else if(validateCaptcha(captcha, true) === false) {
            toast.error(prop.lang === 'en' ? 'Captcha Does Not Match':'กรุณาระบุ อักษรภาพที่เห็น ให้ถูกต้อง');
            refCaptcha.current.focus();
        }
        else {
            setDisabledBtn(true);
            let code = Utils.random5Number;
            let datetime = moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss');
            let param = {
                email: email,
                password: password,
                requestCode: code,
                requestCodeAt: datetime
            };
            const result = await checkLogin(param);
            if(result) {
                setDisabledBtn(false);
                if(result.status === 'success') {
                    //go to thaiD
                    //window.location.href = thaiDLoginUrl;
                    //send verify code
                    if(email === 'user1@usercybre.com' || email === 'user2@usercybre.com') {
                        localStorage.setItem(Utils.LOCAL_STORAGE_KEY, JSON.stringify(result.data));
                        window.location.href = (prop.lang === 'en' ? '/en':'/') + 'profile';
                    }
                    else {
                        setDisabledBtn(true);
                        let datetime = moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss');
                        const sendCode = await sendEmailCode({
                            name: result.fullname,
                            email: email,
                            code: code,
                            datetime: datetime
                        });
                        if(sendCode.status === 1) {
                            setDisabledBtn(false);
                            setIsVerifyCode(true);
                            setEmail(email);
                        }
                        else {
                            toast.error(prop.lang === 'en' ? 'Sorry, Unable to send email at this time':'ขออภัย ไม่สามารถส่งอีเมลได้ในขณะนี้');
                        }
                    }
                }
                else if(result.status === 'email') {
                    toast.error(prop.lang === 'en' ? 'Email not found':'ไม่พบอีเมลนี้ในระบบ');
                }
                else if(result.status === 'suspended') {
                    toast.error(prop.lang === 'en' ? 'Email not found':'บัญชีผู้ใช้งานนี้ ถูกระงับการใช้งานชั่วคราว เป็นเวลา ' + Utils.MEMBER_SUSPENDED_HOUR + ' ชั่วโมง เริ่มตั้งแต่ ' + Utils.dateTimeYMDHI(result.suspendedDate), {
                        duration: 3000,
                    });
                    setTimeout(function () {
                        window.location.href = (prop.lang === 'en' ? '/en':'/');
                    }, 3500);
                }
                else if(result.status === 'delete_account') {
                    toast.error(prop.lang === 'en' ? 'Sorry, this account is in Deleted status. Please contact the administrator.':'ขออภัย บัญชีนี้อยู่ในสถานะ ลบบัญชี กรุณาติดต่อผู้ดูแลระบบ');
                }
                else if(result.status === 'status') {
                    toast.error(prop.lang === 'en' ? 'This user is temporarily suspended':'ขออภัย ผู้ใช้งานนี้ถูกระงับงานชั่วคราว');
                }
                else if(result.status === 'password') {
                    let x = count + 1;
                    setCount(x);
                    toast.error(prop.lang === 'en' ? 'Password is incorrect':'รหัสผ่านไม่ถูกต้อง');
                }
                else {
                    toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator':'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้่ดูแลระบบ');
                }

                if(count >= Utils.MEMBER_LOGIN_FAILED) {
                    await sendEmail({
                        email: email,
                        email_admin: result.email_admin,
                        datetime: datetime
                    });
                    window.location.href = (prop.lang === 'en' ? '/en':'/') + 'forgot';
                }
                if(count >= Utils.MEMBER_SUSPENDED_FAILED) {
                    await suspended({
                        email: email,
                        suspendedDate: datetime
                    });
                }
            }
            else {
                toast.error(prop.lang === 'en' ? 'Sorry, you cannot log in at this time. Please contact your administrator.':'ขออภัย ไม่สามารถเข้าสู่ระบบได้ในขณะนี้ กรุณาติดต่อผู้่ดูแลระบบ');
            }
        }
    };

    async function checkLogin(param) {
        const response = await fetch(Config.apiUrl +'/member/checkLogin', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function suspended(param) {
        const response = await fetch(Config.apiUrl +'/member/suspended', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function sendEmail(param) {
        const response = await fetch(Config.phpUrl +'/email_login_failed.php', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function sendEmailCode(param) {
        const response = await fetch(Config.phpUrl +'/email_login_code.php', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    //region verify code
    let refVerifyCode = React.useRef();
    const onVerify = async () => {
        let code = refVerifyCode.current.value;

        if(code === '' || isNaN(code)) {
            toast.error(prop.lang === 'en' ? 'Please enter the verification code as a 5-digit number.':'กรุณาระบุ รหัสยืนยัน เป็นตัวเลข 5 หลัก');
            refVerifyCode.current.focus();
        }
        else {
            setDisabledBtn(true);
            let datetime = moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss');
            let param = {
                email: email,
                code: code,
                latestLoginAt: datetime
            };
            const result = await checkLoginByCode(param);
            if(result) {
                setDisabledBtn(false);
                if(result.status === 'success') {
                    localStorage.setItem(Utils.LOCAL_STORAGE_KEY, JSON.stringify(result.data));
                    window.location.href = (prop.lang === 'en' ? '/en':'/') + 'profile';
                }
                else if(result.status === 'email') {
                    toast.error(prop.lang === 'en' ? 'Email not found':'ไม่พบอีเมลนี้ในระบบ');
                }
                else if(result.status === 'code') {
                    toast.error(prop.lang === 'en' ? 'Invalid Verify Code':'ไม่พบรหัสยืนยัน หรือรหัสยืนยันไม่ถูกต้อง');
                }
                else if(result.status === 'date') {
                    toast.error(prop.lang === 'en' ? 'Verification code has expired':'รหัสยืนยันหมดอายุแล้ว');
                }
                else if(result.status === 'suspended') {
                    toast.error(prop.lang === 'en' ? 'Email not found':'บัญชีผู้ใช้งานนี้ ถูกระงับการใช้งานชั่วคราว เป็นเวลา ' + Utils.MEMBER_SUSPENDED_HOUR + ' ชั่วโมง เริ่มตั้งแต่ ' + Utils.dateTimeYMDHI(result.suspendedDate), {
                        duration: 3000,
                    });
                    setTimeout(function () {
                        window.location.href = (prop.lang === 'en' ? '/en':'/');
                    }, 3500);
                }
                else if(result.status === 'delete_account') {
                    toast.error(prop.lang === 'en' ? 'Sorry, this account is in Deleted status. Please contact the administrator.':'ขออภัย บัญชีนี้อยู่ในสถานะ ลบบัญชี กรุณาติดต่อผู้ดูแลระบบ');
                }
                else if(result.status === 'status') {
                    toast.error(prop.lang === 'en' ? 'This user is temporarily suspended':'ขออภัย ผู้ใช้งานนี้ถูกระงับงานชั่วคราว');
                }
                else if(result.status === 'password') {
                    let x = count + 1;
                    setCount(x);
                    toast.error(prop.lang === 'en' ? 'Password is incorrect':'รหัสผ่านไม่ถูกต้อง');
                }
                else {
                    toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator':'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้่ดูแลระบบ');
                }

                if(count >= Utils.MEMBER_LOGIN_FAILED) {
                    await sendEmail({
                        email: email,
                        email_admin: result.email_admin,
                        datetime: datetime
                    });
                    window.location.href = (prop.lang === 'en' ? '/en':'/') + 'forgot';
                }
                if(count >= Utils.MEMBER_SUSPENDED_FAILED) {
                    await suspended({
                        email: email,
                        suspendedDate: datetime
                    });
                }
            }
            else {
                toast.error(prop.lang === 'en' ? 'Sorry, you cannot log in at this time. Please contact your administrator.':'ขออภัย ไม่สามารถเข้าสู่ระบบได้ในขณะนี้ กรุณาติดต่อผู้่ดูแลระบบ');
            }
        }
    };

    const onResendCode = () => {
        window.location.reload();
    };

    async function checkLoginByCode(param) {
        const response = await fetch(Config.apiUrl +'/member/loginByCode', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }
    //endregion

    return (
        <>
            <div className="section section-banner small">
                <img src={bannerImage} alt="" />
                <div className="container">
                    <h1 className="h2 textrow">
                        <span data-aos="fade-up">{prop.lang === 'en' ? 'Login':'เข้าสู่ระบบ'}</span>
                    </h1>
                    <p data-aos="fade-in"><NavLink to="/">{prop.lang === 'en' ? 'Home':'หน้าแรก'}</NavLink> / {prop.lang === 'en' ? 'Login':'เข้าสู่ระบบ'} / {prop.lang === 'en' ? 'Researcher':'นักวิจัย'} </p>
                </div>
            </div>

            <div className="section">
                <div className="container py-2">
                    <div className="card-infos has-shadow-black w-1020">

                        <div className="hgroup text-center" data-aos="fade-in">
                            <h2 className="my-2">{prop.lang === 'en' ? 'Login For Researcher':'เข้าสู่ระบบ สำหรับนักวิจัย'}</h2>
                            {
                                isVerifyCode ? <p className="text-black">ระบบได้ส่งรหัสยืนยันตัวตนไปยัง อีเมลของท่านแล้ว กรุณาตรวจสอบรหัสในอีเมล</p> : ''
                            }
                        </div>

                        <div className="boxed" data-aos="fade-in">
                            {
                                isVerifyCode ?
                                    <div className="row g-3">
                                        <div className="col-12">
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'Verification code':'รหัสยืนยัน'} <span className="star">*</span></h6>
                                                <div className="group">
                                                    <input type="text" className="form-control" ref={refVerifyCode} maxLength={5} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 mt-4">
                                            <div className="form-group">
                                                <div className="buttons pt-0">
                                                    <button className="btn btn-primary w-100" type="button" onClick={onVerify} disabled={disabledBtn}>
                                                        {prop.lang === 'en' ? 'Verify code':'ยืนยัน'}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 my-sm-4">
                                            <div className="form-group text-center text-black"><a href="#" onClick={onResendCode} className="link-gray">{prop.lang === 'en' ? 'Resend Code':'ขอรหัสอีกครั้ง'}</a>
                                            </div>
                                        </div>
                                    </div> : <div className="row g-3">
                                        <div className="col-12">
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'Email':'ชื่ออีเมลผู้ใช้งาน'} <span className="star">*</span></h6>
                                                <input type="email" className="form-control" ref={refEmail} placeholder="your@email.com" />
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <div className="form-group">
                                                <h6>{prop.lang === 'en' ? 'Password':'รหัสผ่าน'} <span className="star">*</span></h6>
                                                <div className="group">
                                                    <span className="icons icon-eye right" onClick={e => {setPasswordInputType(passwordInputType === 'password' ? 'text':'password')}}></span>
                                                    <input type={passwordInputType} className="form-control" ref={refPassword} maxLength={20} placeholder={Utils.passwordAlert(prop.lang)} />
                                                </div>
                                            </div>
                                            <div className="d-flex">
                                                <p className="d-flex my-2 me-auto d-none">
                                                    <a href="#" className="link-gray">ลืมชื่อผู้ใช้งาน?</a>
                                                </p>
                                                <p className="d-flex my-2 ms-auto">
                                                    <NavLink to={prop.lang === 'en' ? '/en/forgot':'/forgot'} className="link-gray">{prop.lang === 'en' ? 'Forgot Password':'ลืมรหัสผ่าน?'}</NavLink>
                                                </p>
                                            </div>
                                        </div>

                                        <div className="col-12 mt-0">
                                            <LoadCanvasTemplate reloadText={prop.lang === 'en' ? 'Refresh':'เรียกใหม่'} />
                                        </div>
                                        <div className="col-12 mt-0">
                                            <div className="form-group">
                                                <input type="text" className="form-control" ref={refCaptcha} placeholder={prop.lang === 'en' ? 'Please input captcha':'ระบุอักษรที่เห็น'} maxLength={6} />
                                            </div>
                                        </div>

                                        <div className="col-12 mt-4">
                                            <div className="form-group">
                                                <div className="buttons pt-0">
                                                    <button className="btn btn-primary w-100" type="button" onClick={onSubmit} disabled={disabledBtn}>
                                                        {prop.lang === 'en' ? 'Login':'เข้าสู่ระบบ'}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group text-center">{prop.lang === 'en' ? 'Or':'หรือเข้าสู่ระบบด้วย'}</div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group">
                                                <div className="buttons pt-0">
                                                    <NavLink to={Utils.thaiDLoginUrl} className="btn btn-light-2 w-100" href="#">
                                                        <img src={IconThaID} width="30px" height="30px" alt="" /> {prop.lang === 'en' ? 'Sign In With':'เข้าสู่ระบบด้วยบัญชี'} ThaID
                                                    </NavLink>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 my-sm-4">
                                            <div className="form-group text-center text-black">{prop.lang === 'en' ? 'If you don\'t have an account yet':'หากคุณยังไม่มีบัญชี'} <NavLink to={Utils.thaiDLoginUrl} className="link-underline">{prop.lang === 'en' ? 'Register with ThaiD':'ลงทะเบียนด้วยบัญชี ThaiD'}</NavLink>
                                            </div>
                                        </div>
                                        <div className="col-12 my-sm-4 d-none">
                                            <div className="form-group text-center text-black">{prop.lang === 'en' ? 'If you don\'t have an account yet':'หากคุณยังไม่มีบัญชี'} <NavLink to={Utils.thaiDLoginUrl} className="link-underline">{prop.lang === 'en' ? 'Register':'ลงทะเบียนด้วยบัญชี'}</NavLink>
                                            </div>
                                        </div>
                                    </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <Toaster position="top-right" />
        </>
    );
} 